<template>
	<div class="badge" :class="color">
		<slot class="slot" />
	</div>
</template>

<script>
/**
 * Creates a small pill shaped badge of the specified color.
 */
export default {
	name: 'Badge',
	props: {
		color: {
			type: String,
			default: 'default',
			validator: function (value) {
				return ['blue', 'green', 'default'].indexOf(value) !== -1;
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.badge {
	display: inline-flex;
	align-items: center;
	@include rem(border-radius, 20px);
	@include rem(padding, 4px 12px);
	@include rem(margin-right, 10px);
	@include rem(font-size, 11px);
	@include typo--roboto__bold;
	text-transform: uppercase;
	letter-spacing: 0.02rem;
	line-height: 1;
	color: $white;
	background-color: $b360-color--gray__darker;

	&.green {
		background-color: $b360-color--green__success;
	}
	&.blue {
		background-color: $b360-color--blue;
	}
}
</style>
